import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/(lang)/blogs/(blogsLayoutGroup)/loading.jsx");
